import React from 'react'

const TechButton = ({data}) => {
  return <div className="TechButton ">{data}</div>;
}

export default TechButton
